import React from 'react';
import Promo from './Promo';
import Navigation from './Navigation';

const Header = () => {
  return (
    <>
      <Promo />
      <Navigation />
    </>
  );
}

export default Header;